/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTRANSACTIONTYPE = {
    _1StNonPaymentInstruction: 'ANPI',
    _2NdNonPaymentInstruction: 'BNPI',
    AccountDetailsChange: 'BADC',
    AccountTransfer: 'ATR',
    AdbCharge: 'RS_ADB',
    AddALife: 'ALIF',
    AddDsaIntermediary: 'IADSA',
    AddFpsIntermediary: 'IAFPS',
    AddresseeChange: 'AECH',
    AdHocRebalance: 'RBAD',
    AdminCancel: 'ACAN',
    AdminCancelRefund: 'ACAR',
    AdminCancelUnitCancellation: 'ADMC',
    AdministrationCharge: 'ADCH',
    AibaUpdated: 'PORT',
    AnnualManagementCharge: 'AMC',
    ApplyGovSsiaContribution: 'GOVP',
    ArrearCreated: 'ARR',
    ArrearsPaymentPlan: 'PASR',
    Assignment: 'ASSN',
    AssignmentAcknowledgement: 'AAS',
    AssignmentAdded: 'ASSA',
    AssignmentAmended: 'ASSE',
    AssignmentCancellation: 'CAS',
    AssignmentRemoved: 'ASSR',
    AttachNewAddress: 'ATNA',
    Attribution: 'ATTR',
    AuthorisationAwaiting: 'ATAW',
    AuthorisationNotRequired: 'ATNR',
    AuthorisationSuspended: 'ATAS',
    AutoRebalance: 'RBAT',
    AutoSwitchDisabled: 'NOAU',
    AutoSwitchDisabledSpi: 'NOSPIAU',
    AutomaticPremiumPayment: 'PAAY',
    AutomaticSwitch: 'AUTOSWT',
    BatchCashClearance: 'BCCL',
    BatchCashDelete: 'BDEL',
    BatchCashInput: 'CINP',
    BatchCashNotification: 'CNOT',
    BeneficiaryAmended: 'BNYE',
    BeneficiaryAdded: 'BNYA',
    BeneficiaryChange: 'BNCH',
    BeneficiaryRemoved: 'BNYR',
    BeneficiaryStatement: 'BNST',
    BenefitStatement: 'BFST',
    BillingFrequencyChange: 'BFCH',
    BillingMethodChange: 'BMCH',
    BillingStartDateChange: 'BDCH',
    BonusReserve: 'BNRE',
    BulkSwitch: 'BULKSWT',
    CancelBonusReserves: 'CBRU',
    CancellationForNonPayment: 'CNP',
    CancelledFromInception: 'CFI',
    CancelledFromInceptionRefund: 'CFIR',
    CashInputReceipt: 'CASHREC',
    CashTransfer: 'CTRN',
    ChangeApprefAdminCancel: 'APRC',
    ChangeBilling: 'BILC',
    ClaimsInterimPayment: 'INPY',
    ClientAddressChange: 'CPAC',
    ClientDetailsAmended: 'CLTC',
    ClientDetailsChanged: 'CPDT',
    ClusterManagement: 'CMAN',
    CommissionPayment: 'COMP',
    ComplimentarySwitch: 'FSWT',
    ConsumerPriceIndex: 'CPI',
    CoolOff: 'COOL',
    CoolOffRefund: 'COOR',
    CouponPayment: 'COUP',
    DdAuthorisationAccepted: 'ATAC',
    DdAuthorisationRejected: 'ATRJ',
    DdAuthorisationRequest: 'ATRQ',
    DeathClaim: 'DTH',
    DeathClaimApproved: 'DTHA',
    DeathClaimRegistered: 'DTHR',
    Decrease: 'DECR',
    DisContribAdjustment: 'SCA',
    DsaCommission: 'CDSA',
    FiscalLetter: 'FSLT',
    FpsCommission: 'CFPS',
    FrequencyChange: 'FRCH',
    FullSurrender: 'SUR',
    FullSurrenderRequest: 'SURP',
    FundDividend: 'UAFD',
    FxCharge: 'FXCG',
    FxChargeReversal: 'FXCR',
    Increase: 'INCR',
    InitialCharge: 'INCH',
    IntBulkSwitchRequest: 'IBSQ',
    IntermediaryPolicyTransfer: 'INPT',
    InternalTransfer: 'INTR',
    LeaverLessTwoYears: 'LLE',
    LeaverMoreThanTwoYears: 'LMO',
    LifeAssuredChange: 'LACH',
    LifecycleOptionSwitchedOff: 'LSOF',
    LifecycleOptionSwitchedOn: 'LSON',
    LifecyclePortfolioRebalance: 'LSTL',
    ManualCommissionAdjustment: 'MCAD',
    ManualPremiumPayment: 'MPAY',
    ManualPremiumRejection: 'PRMR',
    MaturityClaim: 'MTR',
    MaturityClaimPending: 'MTRP',
    MoneyboxOptionSwitchedOff: 'MBOF',
    MoneyboxOptionSwitchedOn: 'MBON',
    MoneyboxPortfolioRebalance: 'MBOX',
    NewBusiness: 'NWB',
    NewBusinessReview: 'NWBR',
    NotProceededWith: 'NPW',
    PartRetirement: 'PRTR',
    PartRetirementClaimRequest: 'PRTRP',
    PartSurrender: 'PSU',
    PartSurrenderFee: 'PSCH',
    PartSurrenderRequest: 'PSUP',
    PartialSwitch: 'PSWT',
    PartialSwitchRequest: 'PSWQ',
    PaymentAuthorisation: 'PAUT',
    PaymentOut: 'PAYM',
    PensionAdjOrderMaintenance: 'PADJMNT',
    PolLostDeclarationEncashment: 'LPDE',
    PolLostDeclarationNewDocs: 'LPDN',
    PolicyCancelled: 'PCAN',
    PolicyFee: 'PFEE',
    PolicyHasMatured: 'MTRD',
    PolicyHasRetired: 'RTRD',
    PolicyIndexationRateChange: 'IXCH',
    PolicyLapseFinalisation: 'LAPS',
    PolicyLapsed: 'LPSE',
    PolicyMigrated: 'PCONC1',
    PolicyNotes: 'NOTC',
    PolicyOwnerChange: 'POCH',
    PolicyPaidUp: 'PDUP',
    PolicyPayerChange: 'PYCH',
    PolicyRevoked: 'REVO',
    PolicyStatusChange: 'PLST',
    PolicyTrusteeChange: 'TECH',
    PolicyValuation: 'PVAL',
    PremiumArrearCancellation: 'PARC',
    PremiumChangeDueToIndexationConfirmation: 'PCIC',
    PremiumChangeDueToIndexationNotice: 'PCIN',
    PremiumCollection: 'PCOL',
    PremiumHoliday: 'PHOL',
    PremiumHolidayCancel: 'PHOC',
    PremiumIndexation: 'PRIX',
    PremiumIndexationCancelled: 'PIX_CAN',
    PremiumIndexationSwitchedOff: 'PIX_OFF',
    PremiumIndexationSwitchedOn: 'PIX_ON',
    PremiumPayments: 'PPAY',
    PremiumRefund: 'PRFD',
    PremiumRejection: 'RIDR',
    PrivMedicalAttnRptExistingClient: 'PMRE',
    PrivMedicalAttnRptNewClient: 'PMRN',
    PrivMedicalAttnRptPayment: 'PMRP',
    Proposal: 'PROP',
    QuotationPack: 'QPK',
    Quote: 'QUOT',
    RecalcFundingFactor: 'RCFF',
    RedirectionOnly: 'SROY',
    RedirectionOnlyRequest: 'SROQ',
    RegularPaymentPending: 'WITP',
    RegularPaymentSuspended: 'WITS',
    RegularPremiumDecrease: 'RPDE',
    RegularPremiumIncrease: 'RPIN',
    RegularWithdrawalWITH: 'WITH',
    RegularWithdrawalREGW: 'REGW',
    RegularWithdrawalPending: 'REGWP',
    RegularWithdrawalRequest: 'REGWR',
    RegularWithdrawalSetup: 'WITR',
    RegularWithdrawalSuspended: 'REGWS',
    Reinstatement: 'REIN',
    RemoveDsaIntermediary: 'IRDSA',
    RemoveFpsIntermediary: 'IRFPS',
    RenewalNotice: 'RENO',
    RetirementClaim: 'RTR',
    RetirementClaimRequest: 'RTRP',
    RetirementDateChange: 'REDC',
    RiderBenefitClaim: 'RDR',
    RiskAdded: 'RAWP',
    RiskCharging: 'RSCG',
    RiskRemoved: 'RRWP',
    RiskSetInForce: 'RSIF',
    SetApprovedPending: 'SAP',
    SetInforce: 'SIF',
    SinglePremiumTopUp: 'SPI',
    SinglePremiumTopUpCancellationSPIC: 'SPIC',
    SinglePremiumTopUpCancellationSPCN: 'SPCN',
    SinglePremiumTopUpCancellationCapture: 'SPICC',
    SinglePremiumTopUpNotProvidedWith: 'SPIN',
    SinglePremiumTopUpReview: 'SPIR',
    SinglePremiumTopUpSetInforce: 'SPIS',
    StatementOfResidence: 'SOR',
    SumAssuredDecrease: 'SADE',
    SumAssuredIncrease: 'SAIN',
    Suspension: 'SUS',
    Switch: 'SWIT',
    SwitchAutoRebalanceOff: 'RBOF',
    SwitchAutoRebalanceOn: 'RBON',
    SwitchFeesDisabled: 'SFOF',
    SwitchFeesEnabled: 'SFON',
    SwitchRequest: 'SWTQ',
    SwitchRequestCancelled: 'SWCA',
    SwitchOrRedirection: 'SWRD',
    SwitchOrRedirectionRequestSRDQ: 'SRDQ',
    SwitchOrRedirectionRequestPRDQ: 'PRDQ',
    TrackerStatement: 'TKST',
    TrailCommissionPDFC: 'PDFC',
    TrailCommissionTCOM: 'TCOM',
    TransferIn: 'TRIN',
    TransferPremium: 'TRF',
    TransferPremiumReview: 'TRFR',
    TransferToSuspense: 'TRFS',
    TrustCharges: 'TCS',
    TrustChargesRequest: 'TCSP',
    UnitAdjustment: 'UNAD',
    UnitAdjustmentConversion: 'UCNV',
    UnitCancellation: 'UCAN',
    UnitStatementUNST: 'UNST',
    UnitStatementSMST: 'SMST',
    Windback: 'WIND',
    WindbackToProposal: 'PWBK',
    WithdrawalPayment: 'WTHP',
    DisinvestmentOnDeathNotification: 'DNDINV'
} as const;
export type IAPTRANSACTIONTYPE = typeof IAPTRANSACTIONTYPE[keyof typeof IAPTRANSACTIONTYPE];


export function IAPTRANSACTIONTYPEFromJSON(json: any): IAPTRANSACTIONTYPE {
    return IAPTRANSACTIONTYPEFromJSONTyped(json, false);
}

export function IAPTRANSACTIONTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTRANSACTIONTYPE {
    return json as IAPTRANSACTIONTYPE;
}

export function IAPTRANSACTIONTYPEToJSON(value?: IAPTRANSACTIONTYPE | null): any {
    return value as any;
}

